import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import commonFunc from '../common';

const defaultValue = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"

const FaceBookTextPage = () => {
  const [originalInput, setOriginalinput] = useState(defaultValue);
  const [results, setResults] = useState([]);

  const handleInputText = (event) => {
    setOriginalinput(event.target.value);
  };

  const generateFancyText = (userText) => {
    if (!userText) {
      return
    }
    let baseResult = []
    baseResult = baseResult.concat(commonFunc.forward(userText).split('\n\n'))
    setResults(baseResult)
  }

  const handleCopyClick = (event) => {
    navigator.clipboard.writeText(event.target.value);
    toast.success("Coppied!", {
      position: "bottom-right",
      autoClose: 1000,
    })
  };

  useEffect(() => {
    if (originalInput) {
      generateFancyText(originalInput)
    } else {
      setResults([])
    }
  }, [originalInput])

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Text Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <textarea
              id="inputText"
              rows={8}
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Enter your original text here."
              value={originalInput}
              onChange={handleInputText}
            />
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <button
              onClick={() => setOriginalinput('')}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
          </div>
        </div>
      </div>

      <div className="col-span-full">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>RECOMMEND FOR YOU</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
          <table className="table-auto w-full">
          <tbody>
            { results.map((result, index) =>(
                <>
                  <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={`row-${index}`}>
                    <td className="px-6 py-4">{result}</td>
                    <td className="text-right px-6 py-4" width={200}>
                      <button data-tooltip-target="tooltip-default" value={result} onClick={(event) => handleCopyClick(event)} type="button" class="px-3 py-2 text-xs font-medium text-center inline-flex items-center text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        <svg value={result} class="h-4 w-4 text-white"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path value={result} stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"/>
                        </svg>
                        Copy
                      </button>
                    </td>
                  </tr>
                </>
              ))
            }
          </tbody>
        </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FaceBookTextPage;
